'use es6';

import { Component } from 'react';

//#region Imports
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import emptyFunction from 'react-utils/emptyFunction';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import EmailForm from 'MeetingsLib/components/sections/EmailForm';
import DatePickerSection from 'MeetingsLib/components/sections/DatePickerSection';
import FreemiumBookingUpgradeLink from 'MeetingsLib/components/freemium/FreemiumBookingUpgradeLink';
import TimeOptionsSection from 'MeetingsLib/components/sections/TimeOptionsSection';
import PropertyForm from 'MeetingsLib/components/sections/PropertyForm';
import PropertyFormV2 from 'MeetingsLib/components/sections/PropertyFormV2';
import UserProfile from 'MeetingsBase/models/UserProfile';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
import Branding from 'MeetingsBase/models/Branding';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import FormState from 'MeetingsLib/models/FormState';
import PaymentForm from '../payments/PaymentIframe';
import { BOOKING_STEPS } from 'MeetingsLib/constants/steps';
import { getRecaptchaEnabled, getIsUngatedForAddGuests, getIsUngatedForBlockFreeDomains } from '../../selectors/BookInfoSelectors';
import ErrorBoundary from '../ErrorBoundary';
import EmailFormV2 from '../sections/EmailFormV2';

//#endregion Imports
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FullSizeBookingPage extends Component {
  constructor(props) {
    super(props);
    this.getClassNames = () => {
      const {
        isSalesStarter,
        canTroubleshoot,
        embedded,
        currentStep
      } = this.props;
      const isPaymentStep = currentStep === BOOKING_STEPS.PAYMENT;
      const isPropertyFormStep = !currentStep || currentStep === BOOKING_STEPS.YOUR_INFO;
      const isOnlyMaxWidthContainer = !embedded && isPropertyFormStep;
      return classNames('min-height-0 width-100 m-x-10 p-top-4', isOnlyMaxWidthContainer ? 'fullsize-container-max-width' : 'fullsize-container', isPaymentStep && "fullsize-payments-container fullsize-payments-top", !isSalesStarter && !canTroubleshoot && !embedded && 'p-top-12');
    };
    this.renderEmailForm = () => {
      const {
        branding,
        welcomeScreenInfo,
        meetingChangeId,
        companyAvatar,
        isUngatedForBlockFreeDomains,
        EmailFormMarker
      } = this.props;
      const PreferredEmailForm = isUngatedForBlockFreeDomains ? EmailFormV2 : EmailForm;
      return /*#__PURE__*/_jsx(PreferredEmailForm, {
        branding: branding,
        compact: false,
        logoUrl: welcomeScreenInfo.logoUrl,
        companyAvatar: companyAvatar,
        meetingChangeId: meetingChangeId,
        title: welcomeScreenInfo.title,
        useCompanyLogo: welcomeScreenInfo.useCompanyLogo,
        description: welcomeScreenInfo.description,
        goToNextStep: emptyFunction,
        EmailFormMarker: EmailFormMarker
      });
    };
    this.renderDateTimeStep = () => {
      const {
        avatar,
        companyAvatar,
        headline,
        displayAvatarOption,
        embedded,
        branding,
        profile,
        isFetchingPublicAvailability,
        isSalesStarter,
        DatePickerMarker,
        TimePickerMarker,
        isPreviewed
      } = this.props;
      let dateContainerStyle = null;
      if (embedded && !isSalesStarter) {
        dateContainerStyle = {
          maxHeight: '613px'
        };
      }
      return /*#__PURE__*/_jsx(UICardWrapper, {
        className: "p-all-0 flex-column height-100",
        "data-selenium-test": "booking-schedule-step",
        children: /*#__PURE__*/_jsx(UICardSection, {
          className: "p-all-0 height-100 flex-column",
          children: /*#__PURE__*/_jsxs(UIFlex, {
            className: "height-100",
            direction: "column",
            align: "stretch",
            children: [/*#__PURE__*/_jsxs(UIFlex, {
              direction: "row",
              className: "height-100",
              align: "stretch",
              style: dateContainerStyle,
              children: [/*#__PURE__*/_jsx(UIBox, {
                basis: "50%",
                children: /*#__PURE__*/_jsx(UIFlex, {
                  direction: "column",
                  className: "height-100",
                  children: /*#__PURE__*/_jsx(DatePickerSection, {
                    compact: false,
                    avatar: avatar,
                    companyAvatar: companyAvatar,
                    branding: branding,
                    displayAvatarOption: displayAvatarOption,
                    embedded: embedded,
                    headline: headline,
                    profile: profile,
                    DatePickerMarker: DatePickerMarker,
                    TimePickerMarker: TimePickerMarker,
                    isPreviewed: isPreviewed
                  })
                })
              }), /*#__PURE__*/_jsx(UIBox, {
                basis: "50%",
                children: /*#__PURE__*/_jsx(UIFlex, {
                  direction: "column",
                  className: "height-100",
                  children: /*#__PURE__*/_jsx(TimeOptionsSection, {
                    compact: false,
                    branding: branding,
                    profile: profile,
                    isFetchingPublicAvailability: isFetchingPublicAvailability,
                    TimePickerMarker: TimePickerMarker
                  })
                })
              })]
            }), !isSalesStarter && /*#__PURE__*/_jsx(UIBox, {
              children: /*#__PURE__*/_jsx(FreemiumBookingUpgradeLink, {
                embedded: embedded
              })
            })]
          })
        })
      }, "full-datetime");
    };
    this.renderPropertyForm = () => {
      const {
        branding,
        canSubmitInitialPropertyForm,
        submittingMeeting,
        resetEventDateTime,
        isUngatedForAddGuests
      } = this.props;
      if (isUngatedForAddGuests) {
        return /*#__PURE__*/_jsx(PropertyFormV2, {
          branding: branding,
          canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
          goToPreviousStep: resetEventDateTime,
          submittingMeeting: submittingMeeting,
          compact: false
        }, "full-property");
      }
      return /*#__PURE__*/_jsx(PropertyForm, {
        branding: branding,
        compact: false,
        canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
        goToPreviousStep: resetEventDateTime,
        submittingMeeting: submittingMeeting
      }, "full-property");
    };
    this.renderStep = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailForm();
      }
      if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
        return this.renderDateTimeStep();
      }
      return this.renderPropertyForm();
    };
    this.renderPaymentForm = () => {
      const {
        resetFormState,
        resetConsentResponses,
        branding,
        submittingMeeting,
        recaptchaEnabled
      } = this.props;
      return /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsx(PaymentForm, {
          goToPreviousStep: () => {
            resetFormState();
            resetConsentResponses();
          },
          branding: branding,
          submittingMeeting: submittingMeeting,
          recaptchaEnabled: recaptchaEnabled
        }, "payment-form")
      });
    };
    this.renderStepWithPayment = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState,
        formState,
        legalConsentValid
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailForm();
      }
      if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
        return this.renderDateTimeStep();
      }
      if (!formState || !legalConsentValid) {
        return this.renderPropertyForm();
      }
      return this.renderPaymentForm();
    };
    this.state = {
      doTransition: false
    };
  }
  componentDidUpdate(prevProps, __prevState) {
    const isNewFormStep = this.props.currentStep && prevProps.currentStep !== this.props.currentStep;
    if (isNewFormStep) {
      this.setState({
        doTransition: true
      });
    }
  }
  render() {
    const {
      isPaidMeeting
    } = this.props;
    return /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      className: this.getClassNames(),
      children: /*#__PURE__*/_jsx(CSSTransition, {
        classNames: "step-animation",
        timeout: 500,
        exit: false,
        in: this.state.doTransition,
        onEntered: () => {
          this.setState({
            doTransition: false
          });
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "flex-column min-height-0 width-100 height-100",
          children: isPaidMeeting ? this.renderStepWithPayment() : this.renderStep()
        })
      })
    });
  }
}
FullSizeBookingPage.propTypes = {
  avatar: PropTypes.string,
  companyAvatar: PropTypes.string,
  displayAvatarOption: PropTypes.string,
  welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
  branding: PropTypes.instanceOf(Branding).isRequired,
  canSubmitInitialPropertyForm: PropTypes.bool,
  canTroubleshoot: PropTypes.bool,
  embedded: PropTypes.bool.isRequired,
  headline: PropTypes.string,
  isFetchingPublicAvailability: PropTypes.bool.isRequired,
  isSalesStarter: PropTypes.bool,
  isRescheduling: PropTypes.bool,
  isPaidMeeting: PropTypes.bool,
  meetingChangeId: PropTypes.string,
  resetFormState: PropTypes.func.isRequired,
  recaptchaEnabled: PropTypes.bool.isRequired,
  isUngatedForAddGuests: PropTypes.bool.isRequired,
  isUngatedForBlockFreeDomains: PropTypes.bool.isRequired,
  currentStep: PropTypes.string,
  resetConsentResponses: PropTypes.func.isRequired,
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  shouldShowEmailForm: PropTypes.bool,
  bookingLifecycle: PropTypes.instanceOf(BookingLifecycle).isRequired,
  emailFormState: PropTypes.string,
  formState: PropTypes.instanceOf(FormState),
  legalConsentValid: PropTypes.bool,
  resetEventDateTime: PropTypes.func.isRequired,
  submittingMeeting: PropTypes.bool,
  DatePickerMarker: PropTypes.func.isRequired,
  TimePickerMarker: PropTypes.func.isRequired,
  EmailFormMarker: PropTypes.func.isRequired,
  isPreviewed: PropTypes.bool
};
export default connect(state => ({
  isSalesStarter: state.isSalesStarter,
  isRescheduling: state.isRescheduling,
  meetingChangeId: state.meetingChangeId,
  recaptchaEnabled: getRecaptchaEnabled(state),
  isUngatedForAddGuests: getIsUngatedForAddGuests(state),
  isUngatedForBlockFreeDomains: getIsUngatedForBlockFreeDomains(state)
}), FormActions)(FullSizeBookingPage);